import { Avatar, SxProps, Theme, AvatarProps, Box, Skeleton } from '@mui/material'
import { useState } from 'react';

interface AvatarProp {
    className?: string
    variant?: AvatarProps["variant"];
    sx?: SxProps<Theme>;
    src?: string;
    label?: string;
    alt?: string;
}
const CustomAvatar = ({
    variant, sx, label, src, alt, className
}: AvatarProp) => {
    const [loaded, setLoaded] = useState(!!!src)
    const onLoad = () => {
        setLoaded(true)
    }
    return (
        <>
            <Avatar
                className={className}
                onLoad={onLoad}
                onError={onLoad}
                variant="circular"
                sx={{
                    ...sx,
                    color: "#ffff",
                    width: "30px",
                    height: "30px",
                    fontSize: "1.5rem",
                    textTransform: "uppercase",
                    fontWeight: "500",
                    background: "#e56361",
                    display: loaded ? "flex" : "none"
                }}
                src={src}
                alt={alt}
            >
                {src && label}
            </Avatar>
            {!loaded
                && <Skeleton sx={{
                    height: "40px",
                    width: "30px",
                    borderRadius: 5,
                }} />
            }
        </>
    )
}

export default CustomAvatar
